import {Helmet} from '@dr.pogodin/react-helmet';

import i18n from '@dms/i18n';
import {SettingsTemplate} from '@dms/settings/shared';

import {AccountingCodesList} from './components/AccountingCodesList';

export function AccountingCodes() {
  const title = i18n.t('entity.settings.labels.accountingCodes');

  return (
    <>
      <Helmet title={title} />
      <SettingsTemplate header={{title}} data-testid="accounting-codes-settings-header">
        <AccountingCodesList />
      </SettingsTemplate>
    </>
  );
}
